// Recorded only by a reviewed operational repair, never by ordinary editors.
// This resolves communication work; it is NOT approval or evidence of a new send.
const object = value => {
  if (typeof value === 'string') {
    try { value = JSON.parse(value); } catch { return {}; }
  }
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
};
const id = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : null;

function resolveHistoricalRevisionFollowUp(record) {
  const metadata = object(record?.metadata ?? record?.metadata_json);
  const resolution = object(metadata.historicalRevisionFollowUp);
  const applied = object(metadata.lastAppliedRevision);
  const sourceId = id(record?.id ?? record?.intervention_id);
  const planId = id(record?.actionPlanId ?? record?.action_plan_id);
  const revisionId = id(applied.draftInterventionId ?? applied.draft_intervention_id);
  if (resolution.version !== 1 || !sourceId || !planId || !revisionId ||
      id(resolution.sourceInterventionId) !== sourceId ||
      id(resolution.actionPlanId) !== planId ||
      id(resolution.revisionDraftInterventionId) !== revisionId ||
      !applied.appliedAt || resolution.appliedAt !== applied.appliedAt ||
      !['already_communicated', 'not_required'].includes(resolution.disposition) ||
      typeof resolution.reviewedAt !== 'string' || !Number.isFinite(Date.parse(resolution.reviewedAt)) ||
      typeof resolution.repairId !== 'string' || !resolution.repairId.trim() ||
      typeof resolution.evidenceReference !== 'string' || !resolution.evidenceReference.trim()) return null;
  return {
    disposition: resolution.disposition,
    reviewedAt: resolution.reviewedAt,
    message: resolution.disposition === 'already_communicated'
      ? 'The historical revision correspondence has been reviewed. No further revision letter is required.'
      : 'No revision letter is required for this historical revision, as recorded in the reviewed case history.',
  };
}

module.exports = { resolveHistoricalRevisionFollowUp };
